import { useState } from 'react'
import { Button, Checkbox, TableCell, TableRow, useTheme } from '@mui/material'

import { useMe, useTableItemsCheck } from 'src/hooks'

import { getTableTimestamp } from 'src/common/utils'
import { HelperWrapper } from 'src/components/helper-wrapper'

import { useStyles } from './style'
import { IRatingSettingsBaseWithId } from 'src/types/rating-settings.type'
import { UpdateRatingSettingsForm } from './modals/edit-item'

interface IImpactCategoryRowProps
  extends Pick<ReturnType<typeof useTableItemsCheck>, 'isItemSelected' | 'handleItemCheck'> {
  row: IRatingSettingsBaseWithId
}

export const RatingSettingsItem = ({
  row,
  isItemSelected,
  handleItemCheck,
}: IImpactCategoryRowProps) => {
  const [open, setOpen] = useState(false)
  const classes = useStyles()

  const { data: user } = useMe()
  const theme = useTheme()

  const handleOpen = () => setOpen(true)

  const handleClose = () => setOpen(false)

  return (
    <>
      <TableRow
        style={{
          backgroundColor: theme.palette.custom.white,
          tableLayout: 'fixed',
        }}
      >
        <TableCell width={'10%'} align="center">
          <Checkbox
            checked={isItemSelected(row.id)}
            onChange={handleItemCheck(row.id)}
            sx={{ color: theme.palette.custom.grey2 }}
          />
        </TableCell>
        <TableCell width="15%">{row?.name}</TableCell>
        <TableCell width="10%" align="center">
          {row?.min_points}
        </TableCell>

        <TableCell width="10%" align="center">
          {row.rank_color !== '' && (
            <div className={classes.colorCell}>
              {row.rank_color}
              <div className={classes.colorHolder} style={{ backgroundColor: row.rank_color }} />
            </div>
          )}
        </TableCell>
        <TableCell width="10%" align="center">
          {getTableTimestamp({ date: row.created_at, timezone: user?.timezone })}
        </TableCell>
        <TableCell width="10%" align="center">
          {getTableTimestamp({ date: row.updated_at, timezone: user?.timezone })}
        </TableCell>
        <TableCell width="10%" align="center">
          <Button onClick={handleOpen}>
            <HelperWrapper t="update-button-text" />
          </Button>
        </TableCell>
      </TableRow>
      <UpdateRatingSettingsForm
        handleClose={handleClose}
        open={open}
        id={row.id}
        initial={{
          name: row?.name,
          min_points: row?.min_points,
          rank_color: row?.rank_color ?? undefined,
        }}
      />
    </>
  )
}
